export const getArray = (value: undefined | string | string[]) =>
  !value ? [] : typeof value === 'string' ? [value] : value;

export const truncate = (str: string) => `${str.substring(0, 27)}...`;

export const normalizeTimestamp = (val: string | undefined) => {
  if (!val) return '';

  const date = new Date(val);
  return date.toLocaleString();
};

export const convertSnakeCaseToSentenceCase = (text: string): string => {
  return text
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (l) => l.toUpperCase());
};
